import { createObservable } from './createObservable';

interface SetSnapshotOptions<T> {
    skipEqualValues?: boolean;
    eqFn?: (a: T, b: T) => boolean;
}

export interface Store<T> {
    getSnapshot: () => T;
    setSnapshot: (data: T, options?: SetSnapshotOptions<T>) => void;
    subscribe: (callback: (data: T) => void) => () => void;
    getListenersCount: () => number;
}

export const createStore = <T>(initializer: () => T): Store<T> => {
    const observable = createObservable<T>();

    let snapshot = initializer();
    const getSnapshot = () => snapshot;
    const setSnapshot = (data: T, { skipEqualValues = false, eqFn = Object.is } = {}) => {
        if (skipEqualValues && eqFn(snapshot, data)) return;

        snapshot = data;
        observable.notify(data);
    };

    return {
        getSnapshot,
        setSnapshot,
        subscribe: observable.subscribe,
        getListenersCount: observable.getListenersCount,
    };
};
